import React, { useState, useEffect, useRef } from "react";
import { useReactToPrint } from 'react-to-print';
import {
  Box,
  Grid,
  Button,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  StepConnector,
  Tooltip,
  IconButton,
} from "@mui/material";
import {
  Mail as MailIcon,
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  NavigateNext as NavigateNextIcon,

} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RefundStep1 from "./CreditStep1";
import RefundStep2 from "./CreditStep2";
import CrudButtons from '../../../GlobalFunction/CrudButtons';
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../lib/axios";
import RefundPrint from "./RefundPrint";
import SendIcon from "@mui/icons-material/Send";
import moment from "moment";
import CreditStep1 from "./CreditStep1";
import CreditStep2 from "./CreditStep2";

import { jsPDF } from "jspdf";
import "jspdf-autotable";
import SendVoucherLink from "./SendVoucherLink";


const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  "& .MuiStepConnector-line": {
    borderColor: "#e0e0e0",
    borderTopWidth: 3,
    borderRadius: 1,
    margin: "7px 30px 20px 30px",
  },
}));

const CustomStepIcon = styled("div")(({ theme, ownerState }) => ({
  width: 40,
  height: 40,
  border: "3px solid",
  borderColor: ownerState.active ? "#7c3aed" : "#e0e0e0",
  borderRadius: "50%",
  backgroundColor: "transparent",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: ownerState.active ? "#7c3aed" : "#999",
  fontSize: "1.2rem",
  fontWeight: "bold",
}));

const CustomStepLabel = styled(StepLabel)({
  flexDirection: "column",
  "& .MuiStepLabel-labelContainer": {
    marginTop: "5px",
  },
});

const steps = ["Main", "Details"];

const Refund = () => {
  const [openSendDialog, setOpenSendDialog] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({
    CnId:'',
    CnDt: '',
    CnNo: '',
    ResidentId: "",
    ChkOutStlId: "",
    ChkOutStlNo: "",
    PropId: "",
    PropName: "",
    CnFlag: '',
    AccLedId: '',
    CnVchrRef: '',
    RcdAmt: 0.00,
    CnAmt:0.00,
    AgstBill: 0.00,
    OnacAmt: 0.00,
    OnacBal: 0.00,
    Pyttype: '',
    PytMode: '',
    TrjId: '',
    ChequeNo: '',
    ChqInfvr: '',
    ChqDt: '',
    ClgDt: null,
    BankName: '',
    CardNo: '',
    AccountNo: '',
    IFSC: '',
    Status: '',
    Remark: '',
  });

  const navigate = useNavigate();
   const [CnId, setCnId] = useState(-1);
  const [loading, setLoading] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [residents, setResidents] = useState([]);
  const location = useLocation();
  const [AllTextDisabled, setAllTextDisabled] = useState(false);
  const [AllButtonDisabled, setAllButtonDisabled] = useState(false);
  const UserId = sessionStorage.getItem("UserId");
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const mode = queryParams.get("mode");
    const CnId = queryParams.get("CnId");
    if (mode === "view" && CnId) {
      fetchRefundData(CnId, "R");
    } else {
      handleAdd();
    }
  }, [location.search]);

  const handleSendEmail = async (emailData) => {
    if (!formData.ResidentId || !formData.Email || !formData.PytAdvNo) {
      toast.error("Resident information, email, or voucher number not available");
      return;
    }

    const { toEmails, subject, body } = emailData;
    if (!toEmails || toEmails.length === 0) {
      toast.error("No valid email addresses provided to send the payment advice.");
      return;
    }

    try {
      setLoading(true);

      const doc = generatePDFContent();
      if (!doc) {
        toast.error("Failed to generate PDF document");
        return;
      }

      const pdfData = doc.output('blob'); 
      const reader = new FileReader();
      const pdfBase64 = await new Promise((resolve, reject) => {
        reader.onload = () => resolve(reader.result.split(',')[1]); 
        reader.onerror = reject;
        reader.readAsDataURL(pdfData);
      });

      const pdfDataUri = `data:application/pdf;base64,${pdfBase64}`;
      const pytAdvNo = formData.PytAdvNo;


      const emailPayload = {
        PropId: parseInt(formData.PropId) || 1,
        UserId: parseInt(UserId) || 1,
        // ToEmail: [formData.Email],
        ToEmail: toEmails,
        Subject: subject || `Payment Voucher - ${pytAdvNo}`,
        ImgFolderNm: pytAdvNo,
        Body: body || `Dear ${formData.ResidentName},\n\nThank you for your payment Voucher. Please find attached your payment voucher for ${pytAdvNo} dated ${moment(formData.RecDt, "DD/MM/YYYY").format("DD-MM-YYYY")}.\n\nBest regards,\nClanbridge Living Pvt Ltd`,
        DocAttachments: [
          {
            FileName: `Payment_Advice_${pytAdvNo}.pdf`,
            FileContent: pdfDataUri,
          },
        ],
      };
     
      const response = await axiosInstance.post("EmailRequest/SendEmail", emailPayload);
      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success("Email sent successfully!");
      } else {
        toast.error(response.data.Message || "Failed to send email");
      }
    } catch (error) {
      toast.error(error.response?.data?.Message || "Failed to send email. Please try again.");
    } finally {
      setLoading(false);
      setOpenSendDialog(false);
    }
  };

  const handleSendAdviceEmail = () => {
    if (!formData.Email) {
      toast.error("Email address is required to send the payment voucher.");
      return;
    }
    if (!formData.PytAdvNo) {
      toast.error("Payment Voucher Number is required to send the email.");
      return;
    }
    setOpenSendDialog(true);
  };

  const generatePDFContent = () => {
    try {
      const doc = new jsPDF();
      let yPos = 20;
      const pageWidth = doc.internal.pageSize.width;
      const margin = 20;

      // Header
      doc.setTextColor(99, 91, 255);
      doc.setFontSize(25);
      doc.text(formData.PropName || "No Property Name Available", pageWidth / 2, yPos, { align: "center" });

      yPos += 10;
      doc.setFontSize(18);
      doc.setTextColor(0);
      doc.text("Payment Voucher", pageWidth / 2, yPos, { align: "center" });

      // Summary Table
      doc.autoTable({
        startY: yPos + 5,
        head: [[{ content: "Payment Voucher Summary", colSpan: 4, styles: { halign: "left", fillColor: [99, 91, 255], textColor: 255, fontSize: 14, cellPadding: 3 } }]],
        body: [
          [
            { content: "Payment No", styles: { fontStyle: "bold" } },
            formData.PytAdvNo || "",
            { content: "Payment Date", styles: { fontStyle: "bold" } },
            formData.RecDt ? moment(formData.RecDt, "DD/MM/YYYY").format("DD-MM-YYYY") : "",
          ],
          [
            { content: "Resident Name", styles: { fontStyle: "bold" } },
            formData.ResidentName || "",
            { content: "Mobile No", styles: { fontStyle: "bold" } },
            formData.MobileNo || "",
          ],
          [
            { content: "Email", styles: { fontStyle: "bold" } },
            formData.Email || "",
            { content: "Payment No", styles: { fontStyle: "bold" } },
            formData.PytNo || "",
          ],
          [
            { content: "Amount", styles: { fontStyle: "bold" } },
            formData.RcdAmt || "",
          ],
        ],
        theme: "grid",
        styles: {
          fontSize: 10,
          cellPadding: 3,
          lineColor: [229, 231, 235],
          lineWidth: 0.1,
        },
        alternateRowStyles: {
          fillColor: [249, 250, 251],
        },
        margin: { left: margin, right: margin },
      });

      // Details Table
      yPos = doc.lastAutoTable.finalY + 15;
      doc.setFontSize(16);
      doc.setTextColor(99, 91, 255);
      doc.text("Details", margin, yPos);

      doc.autoTable({
        startY: yPos + 5,
        head: [["Payment No", "Payment Date", "Amount", "Remark"]],
        body: [
          [
            formData.PytNo || "",
            formData.RecDt ? moment(formData.RecDt, "DD/MM/YYYY").format("DD-MM-YYYY") : "",
            formatValue(formData.RcdAmt),
            formData.Remark || "",
          ],
        ],
        theme: "grid",
        styles: {
          fontSize: 10,
          cellPadding: 3,
          lineColor: [229, 231, 235],
          lineWidth: 0.1,
        },
        alternateRowStyles: {
          fillColor: [249, 250, 251],
        },
        margin: { left: margin, right: margin },
      });

      // Footer
      yPos = doc.lastAutoTable.finalY + 15;
      doc.setFontSize(12);
      doc.setTextColor(0);
      doc.text("Thank you for choosing Clanbridge Living Pvt Ltd", margin, yPos);
      doc.text("For any queries, please contact: support@clanbridgeliving.in", margin, yPos + 5);

      return doc;
    } catch (error) {
      return null;
    }
  };

  const formatValue = (value) => {
    if (typeof value === "number") {
      return value.toFixed(2);
    }
    if (value && moment(value, moment.ISO_8601, true).isValid()) {
      return moment(value).format("DD-MM-YYYY");
    }
    return value || "";
  };


   const fetchRefundData = async (CnId, Flag) => {
    try {
      const response = await axiosInstance.post("/Cn/RetriveCnAll", {
        CnId: CnId === -1 ? 1 : CnId,
        Flag: Flag || '',
      });
      if (response.data.Status === 0) {
        const refundData = response.data.Data;
        const cnDetails = refundData.CnDtlEntity?.[0];
        
        console.log('refundData', refundData);
        
        setFormData({
          ...refundData,
          CnId: refundData.CnId,
          CnNo: refundData.CnNo || '',
          CnDt: refundData.CnDt ? moment(refundData.CnDt).format("YYYY-MM-DD") : '',
          PropId: refundData.PropId || '',
          PropName: refundData.PropName || 'No Property Available',
          Email: refundData.Email || '',
          ResidentName: refundData.ResidentName || '',
          MobileNo: refundData.MobileNo || '',
          CnAmt: refundData.CnAmt || 0.00,
          Pyttype: refundData.Pyttype || "Cash",
          CnFlag: refundData.CnFlag || "R",
          AgstBill: refundData.AgstBill || 0.00,
          OnacAmt: refundData.OnacAmt || 0.00,
          OnacBal: refundData.OnacBal || 0.00,
          AccLedId: refundData?.AccLedId || 1,
          CnVchrRef: refundData.CnVchrRef || '',
          Remark: refundData.Remark || '',
          ChequeNo: refundData.ChequeNo || '',
          ChqDt: refundData.ChqDt ? moment(refundData.ChqDt).format("YYYY-MM-DD") : '',
          BankName: refundData.BankName || '',
        });
        
        setCnId(refundData.CnId);
        setAllTextDisabled(true);
        setAllButtonDisabled(false);
      } else {
        toast.error(response.data.Message);
      }
      return response;
    } catch (error) {
      toast.error("Failed to load credit note data");
    }
  };
   const DeleteData = async () => {
    try {
      const response = await axiosInstance.post("/Cn/DeleteCn", {
        CnId: formData.CnId,
      });
      if (response.data.Status === 0) {
        toast.success(response.data.Message);
        return response;
      } else {
        toast.error(response.data.Message);
      }
      return response;
    } catch (error) {
      toast.error("Failed to delete credit note");
    }
  };


  const handleAdd = () => {
    setAllTextDisabled(false);
    setAllButtonDisabled(true);
    setFormData({
      CnId: -1,
      CnNo: "",
      CnDt: "",
      ResidentId: "",
      PropId: "",
      PropName: "",
      CnFlag: "R",
      AccLedId: 1,
      CnVchrRef: "",
      CnAmt: 0.00,
      AgstBill: 0.00,
      OnacAmt: 0.00,
      OnacBal: 0.00,
      Pyttype: "Cash",
      PytMode: "Cash",
      TrjId: "1",
      ChequeNo: "",
      ChqInfvr: "",
      ChqDt: "",
      ClgDt: null,
      BankName: "",
      CardNo: "",
      AccountNo: "",
      IFSC: "",
      Status: "1",
      Remark: "",
    });
    handleStepClick(0);
  };

  const handleEdit = async () => {
    setAllTextDisabled(false);
    setAllButtonDisabled(true);
  };

  const handleExit = () => {
    navigate("/cradit-notestable");
  };

  const handleCancel = async () => {
    if (CnId && (typeof CnId === 'string' ? CnId.trim() !== "" : CnId !== -1)) {
      await fetchRefundData(CnId, "L");
    }
    setAllButtonDisabled(false);
    setAllTextDisabled(true);
    handleStepClick(0);
  };

  const handlePrevious = async () => {
    await fetchRefundData(CnId, "P");
  };

  const handleNext = async () => {
    await fetchRefundData(CnId, "N");
  };

  const handleCancelDelete = () => {
    setOpenDeleteDialog(false);
  };

  const handleDelete = () => {
    setOpenDeleteDialog(true);
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await DeleteData();
      if (response && response.data.Status === 0) {
        handleStepClick(0);
      }
      setOpenDeleteDialog(false);
      setAllTextDisabled(true);
      setAllButtonDisabled(false);
    } catch (error) {
      toast.error("Error while deleting the record");
    }
  };
console.log('formData',formData)
  const renderStepContent = (step) => {
    return (
      <Box sx={{ padding: "5px" }}>
        {step === 0 ? (
          <CreditStep1
            formData={formData}
            setFormData={setFormData}
            AllTextDisabled={AllTextDisabled}
            handleCancel={handleCancel}
            fetchRefundData={fetchRefundData}
            CnId={CnId}
            setAllButtonDisabled={setAllButtonDisabled}
            ResidentId={formData.ResidentId}
            handleStepClick={handleStepClick}
            setCnId={setCnId} 
            onResidentsLoad={(residentsData) => setResidents(residentsData)}
          />
        ) : (
          <CreditStep2
            formData1={formData}
            setFormData={setFormData}
            ResidentId={formData.ResidentId}
            AllButtonDisabledOuter={AllButtonDisabled}
            IsButtonSubmit={AllTextDisabled}
            handleCancel={handleCancel}
            fetchRefundData={fetchRefundData}
             CnId={CnId} 
            setCnId={setCnId} 
            handleStepClick={handleStepClick}
          />
        )}
      </Box>
    );
  };

  const handleStepClick = (step) => {
    setActiveStep(step);
  };

  const buttonSx = {
    backgroundColor: '#635bff',
    borderRadius: '5px',
    padding: '5px',
    margin: { xs: '0px 5px', sm: '0px 5px' },
    "&:hover": {
      backgroundColor: "#1565c0",
      cursor: "pointer",
    },
    minWidth: { xs: '40px', sm: '40px', md: '60px' },
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.26)",
      boxShadow: "none",
    }
  };

  return (
    <Grid>
      <Box className="form-container">
        <ToastContainer />
        <Dialog
          open={openDeleteDialog}
          onClose={handleCancelDelete}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this record?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleConfirmDelete}
              sx={{
                backgroundColor: "#635bff",
                color: "white",
                "&:hover": {
                  backgroundColor: "#1565c0",
                  color: "white",
                },
              }}
            >
              Yes
            </Button>
            <Button
              onClick={handleCancelDelete}
              sx={{
                backgroundColor: "#635bff",
                color: "white",
                "&:hover": {
                  backgroundColor: "#1565c0",
                  color: "white",
                },
              }}
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
        <Grid container spacing={2} className="refund_form">
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: { xs: "column", sm: "row", md: "row" },        
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                marginBottom: { xs: "10px", sm: 0 },

              }}
            >
              <Button
                variant="contained"
                size="small"
                className="three-d-button-previous"
                onClick={handlePrevious}
                sx={{
                  backgroundColor: "#635BFF",
                  marginRight: "8px", 
                }}
                disabled={AllButtonDisabled}
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                className="three-d-button-next"
                onClick={handleNext}
                sx={{
                  backgroundColor: "#635BFF",
                }}
                disabled={AllButtonDisabled}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>

            <Typography
              variant="h5"
              sx={{
                margin: "Auto",
                textAlign: { xs: "center", sm: "center", md: "center" },
                fontSize: { xs: "24px", sm: "18px", md: "24px" },
              }}
            >
              Credit Notes
            </Typography>
            {/* <span>
              <Tooltip title="Send Payment Voucher Mail">
                <IconButton onClick={handleSendAdviceEmail} sx={buttonSx} disabled={loading || !AllTextDisabled}>
                  <SendIcon sx={{ color: "white" }} />
                </IconButton>
              </Tooltip>
            </span> */}
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Receipt Voucher"
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleDelete}
                onExit={handleExit}
                readOnlyMode={!AllButtonDisabled}
                onPrevious={handlePrevious}
                onNext={handleNext}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Stepper activeStep={activeStep} connector={<CustomStepConnector />} alternativeLabel>
              {steps.map((label, index) => (
                <Step
                  key={label}
                  onClick={() => {
                    if (!AllButtonDisabled) {
                      handleStepClick(index);
                    }
                  }}
                  disabled={AllButtonDisabled || (index !== activeStep && AllButtonDisabled)}
                  style={{ cursor: AllButtonDisabled ? "not-allowed" : "pointer" }}
                >
                  <CustomStepLabel
                    StepIconComponent={(props) => (
                      <CustomStepIcon ownerState={{ ...props, active: activeStep === index }}>
                        {index + 1}
                      </CustomStepIcon>
                    )}
                  >
                    {label}
                  </CustomStepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>
          <Grid item xs={12}>
            {renderStepContent(activeStep)}
          </Grid>
        </Grid>
      </Box>
      <div style={{ display: 'none' }}>
        <RefundPrint contentRef={contentRef} formData={formData} residents={residents} />
      </div>

      <SendVoucherLink
        open={openSendDialog}
        onClose={() => setOpenSendDialog(false)}
        onSend={handleSendEmail}
        initialEmail={formData.Email}
        residentName={formData.ResidentName}
      />
    </Grid>
  );
}

export default Refund;